import React, { useRef } from "react";
import LabelContainer from "../LabelContainer";
import EmptyButton from "./EmptyButton";

const TextareaInput = ({
  k = -1,
  autoFocus,
  autocomplete = "on",
  inputStyle = {},
  inputClassName = "",
  type,
  disabled = false,
  id = null,
  value,
  change = () => {},
  placeholder = "",
  ...props
}) => {
  const inputRef = useRef(null);

  return (
    <LabelContainer {...props} value={value}>
      <textarea
        ref={inputRef}
        autoFocus={autoFocus}
        autoComplete={autocomplete}
        style={inputStyle}
        className={"form-control " + inputClassName}
        type="text"
        disabled={disabled ? "disabled" : false}
        id={k != -1 ? props.name + "-" + k : id ? id : props.name}
        name={props.name}
        value={value}
        onChange={k != -1 ? (e) => change(e, k) : change}
        placeholder={placeholder}
        rows="10"
      />
      <EmptyButton change={change} name={props.name} targetInput={inputRef} value={value} />
    </LabelContainer>
  );
};

export default TextareaInput;
